export enum OfficeType {
  umF = "umF",
  GVS = "GVS",
  KJH = "KJH",
}
